import {
  AddIncrementStepMessage,
  BroadcastMessage,
  FairWarningMessage,
  IncomeWebsocketMessage, LogStreamStatistics,
  OpenLotMessage,
  PassLotMessage,
  PauseMessage,
  PlaceBidMessage,
  PlaceInterestMessage,
  RemoveBroadcastMessage,
  RemoveIncrementStepMessage,
  RemoveInterestMessage,
  ResetLotMessage,
  ResolveSoldLotMessage,
  SellLotMessage,
  SetAskingMessage,
  SetManualIncrementMessage,
  SetStreamStatusMessage,
  StoreBroadcastMessage,
  UndoBidMessage
} from "@/types/websocketMessages/incomeMessages";
import { ActionPayload, Store } from "vuex";
import { DARStore } from "@/types/store";
import { connection } from "@/store/plugins/websocket/createConnection";
import { uuidv4 } from "@/helpers/uuid";
import {
  FinishAuctionMessage,
  StartAuctionMessage
} from "@/types/websocketMessages/outcomeMessages";

export const sendWebsocketMessage = (message: IncomeWebsocketMessage) => {
  if (connection.readyState === WebSocket.OPEN) {
    message.id = uuidv4();
    connection.send(JSON.stringify(message));
  } else {
    console.error("sending WS when connection is down", message);
  }
};

export const sendOutgoingMessages = (
  action: ActionPayload,
  store: Store<DARStore>
) => {
  switch (action.type) {
    case "clerkSelectLot": {
      const wsData: OpenLotMessage = {
        type: "openLot",
        id: "",
        lotNumber: action.payload
      };
      sendWebsocketMessage(wsData);
      break;
    }
    case "clerkPlaceBid": {
      const wsData: PlaceBidMessage = {
        type: "placeBid",
        id: "",
        lotNumber: action.payload.lotNumber,
        value: action.payload.value
      };
      sendWebsocketMessage(wsData);
      break;
    }
    case "finishAuction": {
      const wsData: FinishAuctionMessage = {
        type: "finishAuction",
        id: "",
        isFinished: action.payload.isFinished
      };
      sendWebsocketMessage(wsData);
      break;
    }
    case "clerkSellLot": {
      const wsData: SellLotMessage = {
        type: "sellLot",
        id: "",
        lotNumber: action.payload.lotNumber,
        provisional: action.payload.provisional,
        paddleNumber: action.payload.paddle
      };
      sendWebsocketMessage(wsData);
      break;
    }
    case "clerkResolveSoldLot": {
      const wsData: ResolveSoldLotMessage = {
        type: "resolveSoldLot",
        id: "",
        lotNumber: action.payload.lotNumber
      };
      sendWebsocketMessage(wsData);
      break;
    }
    case "clerkPassLot": {
      const wsData: PassLotMessage = {
        type: "passLot",
        lotNumber: action.payload.lotNumber,
        id: ""
      };
      sendWebsocketMessage(wsData);
      break;
    }
    case "clerkUndoBid": {
      const wsData: UndoBidMessage = {
        type: "undoBid",
        lotNumber: store.getters.currentLot?.number || "",
        bidId: action.payload.bidId,
        id: ""
      };
      sendWebsocketMessage(wsData);
      break;
    }
    case "clerkSetAskingPrice": {
      const wsData: SetAskingMessage = {
        type: "setAsking",
        value: action.payload.value,
        lotNumber: action.payload.lotNumber,
        id: ""
      };
      sendWebsocketMessage(wsData);
      break;
    }
    case "clerkBroadcastMessage": {
      const wsData: BroadcastMessage = {
        type: "broadcastMessage",
        content: action.payload.message,
        isAlert: action.payload.isAlert,
        id: ""
      };
      // prevent empty messages
      if (action.payload.message) sendWebsocketMessage(wsData);
      break;
    }
    case "clerkSetPause": {
      const wsData: PauseMessage = {
        type: "setPause",
        isPause: action.payload.isPause,
        endTime: action.payload.endTime,
        icon: action.payload.icon,
        message: action.payload.message,
        id: ""
      };
      sendWebsocketMessage(wsData);
      break;
    }
    case "resetLot": {
      const wsData: ResetLotMessage = {
        type: "resetLot",
        lotNumber: action.payload.lotNumber,
        id: ""
      };
      sendWebsocketMessage(wsData);
      break;
    }
    case "clerkFairWarn": {
      const wsData: FairWarningMessage = {
        type: "fairWarning",
        lotNumber: action.payload.lotNumber,
        level: action.payload.level,
        id: ""
      };
      sendWebsocketMessage(wsData);
      break;
    }

    case "manuallyAddOnlineInterest": {
      const wsData: PlaceInterestMessage = {
        type: "placeInterest",
        id: "",
        lotNumber: action.payload.lotNumber
      };
      sendWebsocketMessage(wsData);
      break;
    }
    case "manuallyRemoveOnlineInterest": {
      const wsData: RemoveInterestMessage = {
        type: "removeInterest",
        id: "",
        lotNumber: action.payload.lotNumber
      };
      sendWebsocketMessage(wsData);
      break;
    }
    case "setSaleIsManualIncrement": {
      const wsData: SetManualIncrementMessage = {
        type: "setManualIncrement",
        id: "",
        isManual: action.payload.isManualIncrement,
        value: action.payload.value,
        lotNumber: action.payload.lotNumber
      };
      sendWebsocketMessage(wsData);
      break;
    }
    case "addManualIncrement": {
      const wsData: AddIncrementStepMessage = {
        type: "addIncrementStep",
        id: "",
        value: parseInt(action.payload.value)
      };
      sendWebsocketMessage(wsData);
      break;
    }
    case "removeManualIncrement": {
      const wsData: RemoveIncrementStepMessage = {
        type: "removeIncrementStep",
        id: "",
        value: parseInt(action.payload.value)
      };
      sendWebsocketMessage(wsData);
      break;
    }
    case "clerkSaveBroadcastMessage": {
      const wsData: StoreBroadcastMessage = {
        type: "storeBroadcastMessage",
        id: "",
        content: action.payload.message
      };
      sendWebsocketMessage(wsData);
      break;
    }
    case "clerkRemoveBroadcastMessage": {
      const wsData: RemoveBroadcastMessage = {
        type: "removeBroadcastMessage",
        id: "",
        content: action.payload.message
      };
      sendWebsocketMessage(wsData);
      break;
    }
    case "setStreaming": {
      const wsData: SetStreamStatusMessage = {
        type: "setStreamStatus",
        id: "",
        isStreaming: action.payload
      };
      sendWebsocketMessage(wsData);
      break;
    }
    case "clerkStartAuction": {
      const wsData: StartAuctionMessage = {
        type: "startAuction",
        id: ""
      };
      sendWebsocketMessage(wsData);
      break;
    }
    case "logStreamStatistics": {
      const wsData: LogStreamStatistics = {
        type: "logStreamStatistics",
        id: "",
        statistics: action.payload
      }
      sendWebsocketMessage(wsData);
      break;
    }
  }
};
